export const getDisplayName = (user) => {
  if (user) {
    if (user.display_name) return user.display_name
    if (user.first_name && user.last_name)
      return `${user.first_name} ${user.last_name[0]}.`
  }

  return ""
}
